// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"c761b45681f82800","3448":"0829d9a513791120"}[chunkId] + ".css";
};